import * as types from '../../actions/actiontypes';
import initialstate from '../initialstate';

export function itcontrolDetailsReducer(state = initialstate.controlsDetails, action) {
	switch (action.type) {
		case types.GET_ITCONTROL_BY_ID:
			return action.response || state;
		default:
			return state;
	}
}
